<script setup>
/* global axios */
// Icerik > Genel Bakis: "su an ne durumdayim" ekrani.
//
// Bes sayi + iki kisa liste. Sayilar SUS DEGIL, birer kapi: her karta
// tiklandiginda o sayiyi ureten listeye gidilir. Tiklanamayan bir sayi
// kullaniciyi "peki simdi nereye" diye birakirdi.
//
// Ham 'axios' PAKETINI ice aktarmiyoruz. Chatwoot kimlik basliklarini
// window.axios uzerinde tutuyor; paketten gelen ornek 401 doner.
import { computed, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';
import Button from 'dashboard/components-next/button/Button.vue';
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';
import {
  DURUM_ANAHTARLARI,
  DURUM_RENKLERI,
  HEDEF_DURUM_RENKLERI,
  hataMetniniCoz,
  hedefAnahtari,
  ozetle,
  platformSimgesi,
  zamanMetni,
} from './icerik-ortak';

const { t, locale } = useI18n();
const route = useRoute();
const router = useRouter();

const uc = computed(() => `/api/v1/accounts/${route.params.accountId}/icerik`);

// Kartlar. `hedef` her kartin acacagi ekran: sayilar birer kapi.
//
// 'hata' karti hem 'hata' hem 'kismi' gonderileri sayiyor (sunucu da oyle
// sayiyor); suzgec de ikisini birlikte aciyor - sayi ile liste birbirini
// tutsun.
const KARTLAR = [
  {
    alan: 'yayinlandi_7g',
    anahtar: 'ICERIK.KART_YAYINLANDI_7G',
    simge: 'i-lucide-send',
    renk: 'text-n-teal-11',
    hedef: { ad: 'icerik_liste', sorgu: { durum: 'yayinlandi' } },
  },
  {
    alan: 'planli',
    anahtar: 'ICERIK.KART_PLANLI',
    simge: 'i-lucide-calendar-clock',
    renk: 'text-n-blue-11',
    hedef: { ad: 'icerik_takvim', sorgu: {} },
  },
  {
    alan: 'taslak',
    anahtar: 'ICERIK.KART_TASLAK',
    simge: 'i-lucide-file-pen-line',
    renk: 'text-n-slate-11',
    hedef: { ad: 'icerik_taslaklar', sorgu: {} },
  },
  {
    alan: 'onay_bekleyen',
    anahtar: 'ICERIK.KART_ONAY_BEKLEYEN',
    simge: 'i-lucide-check-check',
    renk: 'text-n-amber-11',
    hedef: { ad: 'icerik_onaylar', sorgu: {} },
  },
  {
    alan: 'hata',
    anahtar: 'ICERIK.KART_HATA',
    simge: 'i-lucide-triangle-alert',
    renk: 'text-n-ruby-11',
    hedef: { ad: 'icerik_liste', sorgu: { durum: 'hata,kismi' } },
  },
];

const ozet = ref(null);
const yukleniyor = ref(true);
const hata = ref('');

const yukle = async () => {
  yukleniyor.value = true;
  hata.value = '';
  try {
    const { data } = await axios.get(`${uc.value}/ozet`);
    ozet.value = data || null;
  } catch (e) {
    hata.value = hataMetniniCoz(e, t('ICERIK.HATA_BILINMEYEN'));
  } finally {
    yukleniyor.value = false;
  }
};

onMounted(yukle);

const sayi = alan => Number(ozet.value?.[alan] ?? 0);

// Listedeki kapak gorseli. Omnup'ta hazirlanan gonderide medya kutuphanesi
// kaydi, hesaptan getirilen gonderide Meta'nin adresi var.
const onizleme = gonderi =>
  gonderi.medya?.find(m => m.tur === 'gorsel' && m.url)?.url ||
  gonderi.secenekler?.kaynak_gorsel ||
  '';

// Meta'nin onizleme adresi zamanla gecersizlesebiliyor; yuklenemeyeni
// gostermek yerine yer tutucuya dusuyoruz.
const gorselHatasi = ref(new Set());
const gorseliGizle = id => {
  gorselHatasi.value = new Set(gorselHatasi.value).add(id);
};
const kapakVar = gonderi =>
  Boolean(onizleme(gonderi)) && !gorselHatasi.value.has(gonderi.id);

const son = computed(() => ozet.value?.son || []);
const yaklasan = computed(() => ozet.value?.yaklasan || []);

// Hic gonderi yok mu? Bes sayinin toplami da iki liste de bossa bu hesapta
// henuz hic icerik uretilmemis demektir. "Suzgece uyan icerik yok"tan FARKLI
// bir mesaj gosteriyoruz: burada suzgec yok, gercekten bos.
const hicIcerikYok = computed(() => {
  if (!ozet.value) return false;
  const toplam = KARTLAR.reduce((t2, kart) => t2 + sayi(kart.alan), 0);
  return toplam === 0 && !son.value.length && !yaklasan.value.length;
});

const kartaGit = kart =>
  router.push({
    name: kart.hedef.ad,
    params: { accountId: route.params.accountId },
    query: kart.hedef.sorgu,
  });

const olusturaGit = () =>
  router.push({
    name: 'icerik_olustur',
    params: { accountId: route.params.accountId },
  });

// Satira tiklaninca gonderiyi listede acar. Ayri bir detay rotasi YOK:
// gonderinin tam hali listedeki satirin kendisinde duruyor, ikinci bir ekran
// acmak ayni bilgiyi iki yerde tutmak olurdu.
const gonderiyeGit = gonderi =>
  router.push({
    name: 'icerik_liste',
    params: { accountId: route.params.accountId },
    query: { gonderi: gonderi.id },
  });

const durumMetni = gonderi =>
  t(DURUM_ANAHTARLARI[gonderi.durum] || 'ICERIK.DURUM_TASLAK');

const durumRengi = gonderi =>
  DURUM_RENKLERI[gonderi.durum] || DURUM_RENKLERI.taslak;

const hedefRengi = hedef =>
  HEDEF_DURUM_RENKLERI[hedef.durum] || HEDEF_DURUM_RENKLERI.bekliyor;

const metinOzeti = gonderi =>
  ozetle(gonderi.metin, 90) || t('ICERIK.METINSIZ');

// Satirda hangi zamani yazalim? Yaklasan liste icin plan zamani, gecmis icin
// olusturulma zamani anlamli. Tek bir alan yazmak, listelerin birinde hep
// yanlis zamani gostermek olurdu.
const zamanSatiri = gonderi => {
  const dil = locale.value;
  if (gonderi.yayin_zamani) {
    return gonderi.durum === 'yayinlandi' || gonderi.durum === 'kismi'
      ? t('ICERIK.ZAMAN_YAYINLANDI', {
          zaman: zamanMetni(gonderi.yayin_zamani, dil),
        })
      : t('ICERIK.ZAMAN_PLANLANDI', {
          zaman: zamanMetni(gonderi.yayin_zamani, dil),
        });
  }
  return t('ICERIK.ZAMAN_OLUSTURULDU', {
    zaman: zamanMetni(gonderi.olusturulma, dil),
  });
};

// Hata metni GIZLENMEZ: hedeflerden biri patladiysa kullanici sebebini
// gormeden duzeltemez. Genel Bakis'ta yer dar oldugu icin ilk hatayi
// yaziyoruz, geri kalani listede duruyor.
const ilkHata = gonderi =>
  (gonderi.hedefler || []).find(h => h.durum === 'hata' && h.hata)?.hata || '';
</script>

<template>
  <div class="flex flex-col gap-6 p-6">
    <div v-if="yukleniyor" class="flex justify-center p-10">
      <Spinner class="text-n-brand" />
    </div>

    <div v-else-if="hata" class="flex flex-col items-start gap-3">
      <p class="text-sm text-n-ruby-11">{{ hata }}</p>
      <Button
        size="sm"
        variant="faded"
        icon="i-lucide-refresh-cw"
        :label="t('ICERIK.YENIDEN_DENE')"
        @click="yukle"
      />
    </div>

    <template v-else>
      <!-- Hic icerik yoksa kartlar bes tane sifir gosterirdi; bu, ekrani
           "bozuk" hissettiriyor. Bunun yerine ne yapilacagini soyluyoruz. -->
      <div
        v-if="hicIcerikYok"
        class="max-w-xl p-10 mx-auto text-center border rounded-lg border-n-weak"
      >
        <span
          class="inline-grid mb-3 rounded-full size-10 place-content-center bg-n-alpha-1 text-n-slate-11"
        >
          <span class="i-lucide-image size-5" />
        </span>
        <p class="text-sm font-medium text-n-slate-12">
          {{ t('ICERIK.BOS_BASLIK') }}
        </p>
        <p class="mt-1 mb-4 text-xs text-n-slate-11">
          {{ t('ICERIK.BOS_ACIKLAMA') }}
        </p>
        <Button
          size="sm"
          variant="solid"
          icon="i-lucide-plus"
          :label="t('ICERIK.SEKME_OLUSTUR')"
          @click="olusturaGit"
        />
      </div>

      <template v-else>
        <section
          class="grid gap-3 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5"
        >
          <button
            v-for="kart in KARTLAR"
            :key="kart.alan"
            type="button"
            class="flex items-center gap-3 p-4 text-left transition-all border rounded-xl border-n-weak bg-n-solid-1 hover:border-n-slate-6 hover:shadow-sm"
            @click="kartaGit(kart)"
          >
            <span
              class="grid shrink-0 rounded-lg size-10 place-content-center bg-n-alpha-1"
            >
              <span :class="[kart.simge, kart.renk]" class="size-5" />
            </span>
            <span class="flex flex-col min-w-0 gap-0.5">
              <span class="text-2xl font-semibold leading-none text-n-slate-12">
                {{ sayi(kart.alan) }}
              </span>
              <span class="text-xs truncate text-n-slate-11">
                {{ t(kart.anahtar) }}
              </span>
            </span>
          </button>
        </section>

        <!-- 2/1: "Son gonderiler" her zaman dolu, "Yaklasan plan" cogu
             zaman bos. Esit bolmek ekranin yarisini bosluga ayiriyordu. -->
        <div class="grid gap-6 xl:grid-cols-3">
          <!-- Son gonderiler -->
          <section class="min-w-0 xl:col-span-2">
            <div class="flex items-center gap-2 mb-3">
              <h2 class="text-sm font-medium text-n-slate-12">
                {{ t('ICERIK.SON_BASLIK') }}
              </h2>
              <span class="grow" />
              <Button
                size="xs"
                variant="link"
                color="slate"
                :label="t('ICERIK.HEPSINI_GOR')"
                @click="
                  router.push({
                    name: 'icerik_liste',
                    params: { accountId: route.params.accountId },
                  })
                "
              />
            </div>

            <p v-if="!son.length" class="text-xs text-n-slate-11">
              {{ t('ICERIK.SON_BOS') }}
            </p>

            <ul v-else class="flex flex-col gap-2 list-none">
              <li v-for="gonderi in son" :key="gonderi.id">
                <button
                  type="button"
                  class="flex w-full gap-3 p-3 text-left transition-all border rounded-xl border-n-weak bg-n-solid-1 hover:border-n-slate-6 hover:shadow-sm"
                  @click="gonderiyeGit(gonderi)"
                >
                  <img
                    v-if="kapakVar(gonderi)"
                    :src="onizleme(gonderi)"
                    alt=""
                    class="object-cover rounded-lg shrink-0 size-14 bg-n-alpha-1"
                    @error="gorseliGizle(gonderi.id)"
                  />
                  <span
                    v-else
                    class="grid rounded-lg shrink-0 size-14 place-content-center bg-n-alpha-1 text-n-slate-10"
                  >
                    <span class="i-lucide-image size-5" />
                  </span>

                  <span class="flex flex-col min-w-0 gap-1.5 grow">
                  <span class="flex flex-wrap items-center gap-2">
                    <span
                      class="px-2 py-0.5 text-xs rounded-md"
                      :class="durumRengi(gonderi)"
                    >
                      {{ durumMetni(gonderi) }}
                    </span>
                    <span
                      v-for="hedef in gonderi.hedefler"
                      :key="hedefAnahtari(hedef)"
                      class="flex items-center gap-1 text-xs"
                      :class="hedefRengi(hedef)"
                      :title="hedef.ad || ''"
                    >
                      <span
                        :class="platformSimgesi(hedef.platform)"
                        class="size-3.5"
                      />
                      <span class="max-w-[8rem] truncate">{{ hedef.ad }}</span>
                    </span>
                  </span>

                  <span class="text-sm text-n-slate-12 line-clamp-2">
                    {{ metinOzeti(gonderi) }}
                  </span>

                  <!-- Hata metni kirmizi ve GORUNUR; gizlenirse kullanici
                       neyi duzeltecegini bilemez. -->
                  <span
                    v-if="ilkHata(gonderi)"
                    class="text-xs text-n-ruby-11 line-clamp-2"
                  >
                    {{ ilkHata(gonderi) }}
                  </span>

                  <span class="text-xs text-n-slate-11">
                    {{ zamanSatiri(gonderi) }}
                  </span>
                  </span>
                </button>
              </li>
            </ul>
          </section>

          <!-- Yaklasan plan -->
          <section class="min-w-0">
            <div class="flex items-center gap-2 mb-3">
              <h2 class="text-sm font-medium text-n-slate-12">
                {{ t('ICERIK.YAKLASAN_BASLIK') }}
              </h2>
              <span class="grow" />
              <Button
                size="xs"
                variant="link"
                color="slate"
                :label="t('ICERIK.TAKVIMDE_GOR')"
                @click="
                  router.push({
                    name: 'icerik_takvim',
                    params: { accountId: route.params.accountId },
                  })
                "
              />
            </div>

            <div
              v-if="!yaklasan.length"
              class="flex flex-col items-center gap-3 px-4 py-8 text-center border border-dashed rounded-xl border-n-weak"
            >
              <span
                class="grid rounded-full size-10 place-content-center bg-n-alpha-1 text-n-slate-10"
              >
                <span class="i-lucide-calendar-clock size-5" />
              </span>
              <p class="text-xs text-n-slate-11">
                {{ t('ICERIK.YAKLASAN_BOS') }}
              </p>
              <Button
                size="sm"
                variant="faded"
                icon="i-lucide-plus"
                :label="t('ICERIK.SEKME_OLUSTUR')"
                @click="olusturaGit"
              />
            </div>

            <ul v-else class="flex flex-col gap-2 list-none">
              <li v-for="gonderi in yaklasan" :key="gonderi.id">
                <button
                  type="button"
                  class="flex flex-col w-full gap-1.5 p-3 text-left transition-all border rounded-xl border-n-weak bg-n-solid-1 hover:border-n-slate-6 hover:shadow-sm"
                  @click="gonderiyeGit(gonderi)"
                >
                  <span class="text-xs text-n-blue-11">
                    {{
                      t('ICERIK.ZAMAN_PLANLANDI', {
                        zaman: zamanMetni(gonderi.yayin_zamani, locale),
                      })
                    }}
                  </span>
                  <span class="text-sm text-n-slate-12 line-clamp-2">
                    {{ metinOzeti(gonderi) }}
                  </span>
                  <span class="flex flex-wrap items-center gap-2">
                    <span
                      v-for="hedef in gonderi.hedefler"
                      :key="hedefAnahtari(hedef)"
                      class="flex items-center gap-1 text-xs text-n-slate-11"
                      :title="hedef.ad || ''"
                    >
                      <span
                        :class="platformSimgesi(hedef.platform)"
                        class="size-3.5"
                      />
                      <span class="max-w-[8rem] truncate">{{ hedef.ad }}</span>
                    </span>
                  </span>
                </button>
              </li>
            </ul>
          </section>
        </div>
      </template>
    </template>
  </div>
</template>
